<!--仓库发起采购页面--镜架-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" >&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td  style="padding-bottom: 10px" colspan="2">
            <el-radio-group v-model="isBackorder" size="mini" :fill="isBackorder?'#F56C6C':'#67C23A'">
              <el-radio-button :label="false">采购单</el-radio-button>
              <el-radio-button :label="true" >退货单</el-radio-button>
            </el-radio-group>
          </td>
        </tr>
        <tr class="noborder" style="height: 44px">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right">供应商：</td>
          <td width="160">
            <el-select v-model="pcustomerserial" placeholder="请选择" size="mini" filterable  @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td align="right"  width="80">类&nbsp;&nbsp;别：</td>
          <td  >
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :treeWidth="450"
                        :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                        :treeHeight="300" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
        </tr>
        <tr class="noborder" style="display: none">
          <td align="right">订单号：</td>
          <td>系统自动生成</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
        </tr>
        <tr class="noborder">

          <td align="right" v-if="!ssotoken">供应号：</td>
          <td v-if="!ssotoken">
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="供应商单号" onfocus="this.select()"></el-input>
          </td>
          <!--<td align="right" width="80">跟踪号：</td>-->
          <!--<td>-->
            <!--<el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号" style="width: 160px"-->
                      <!--onfocus="this.select()"></el-input>-->
          <!--</td>-->
          <td colspan="2" style="padding-left: 30px"></td>
          <td align="right" >EMail：</td>
          <td>{{controlData.email}}</td>
        </tr>
        <tr class="noborder" style="height: 44px">
          <td colspan="2"><span ><b>{{pingpainame}}</b></span><span style="margin-left: 20px">总数：<b>{{totalnumber}}</b></span></td>
          <td style="padding-right: 30px;text-align: right" colspan="4">
            <template v-if="!fixedprice">
            <el-button type="warning" @click="loadfromorder" size="mini" v-if="pcustomerserial" plain >从采购单导入</el-button>
            <el-button type="warning" v-on:click="jingjiaupload" size="mini" plain>Excel导入</el-button>
            &nbsp;&nbsp;<a href="./static/file/镜架导入模板.xlsx" >下载模板</a>&nbsp;&nbsp;&nbsp;
            </template>
            <el-button size="mini" type="warning"  @click.stop.prevent="addGood()">增加</el-button>
            <el-button size="mini" type="warning" @click.stop.prevent="showGoodDetailSel()" v-if="!fixedprice">选择</el-button>
            <el-button size="mini" type="danger" @click.stop.prevent="fastCheckIn()" v-if="ssotoken&&(form.seedcode||UGO)" icon="el-icon-shopping-cart-full">供应商订单</el-button><!--showSupplySel-->
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData.filter(data => !searchmodel || data.model.toUpperCase().includes(searchmodel.toUpperCase()))"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="编码"
                align="center"
                width="60"
                :show-overflow-tooltip="true"
                header-align="center">
              </el-table-column>
              <el-table-column
              prop="seedname"
              label="名称"
              :show-overflow-tooltip="true"
              align="left"
              header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                width="160"
                align="center"
                header-align="center">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="searchmodel"    size="mini" placeholder="输入型号搜索"/>
                </template>
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="numChange(scope.row)"></el-input>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="barcodes"-->
                <!--label="扫码"-->
                <!--align="left"-->
                <!--header-align="center">-->
                <!--<template slot-scope="scope">-->
                  <!--<el-input style="width: 80%" size="mini" v-model="scope.row.onlycode"-->
                            <!--:ref="'code'+scope.row.id"-->
                            <!--onfocus="this.select()"-->
                            <!--@keyup.down.native="validateCounts(scope.row,scope.$index, $event,'code')"-->
                            <!--@keyup.up.native="validateCounts(scope.row,scope.$index, $event,'code')"-->
                            <!--@change="selectonlyonecode(scope.row)"></el-input>-->
                  <!--<div v-for="item in scope.row.barcodes" :key="item.storegoodsbarcode">-->
                    <!--{{item.storegoodsbarcode}}&nbsp;&nbsp;&nbsp;<i class="el-icon-close" style="cursor: pointer" @click="clearBar(item.storegoodsbarcode,scope.row)"></i>-->
                  <!--</div>-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column label="操作" align="center" width="130">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>采购要求：</td>
          <td colspan="5">
            <el-input  type="textarea" :rows="4" style="width: 100%;min-height: 40px" v-model="controlData.remark" ></el-input>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button @click="createBarcode('ewm')" :loading="loading" size="small" icon="el-icon-menu" v-if="!isBackorder">打印二维码</el-button>
      <el-button @click="createBarcode('')" :loading="loading" size="small" icon="el-icon-s-data" v-if="!isBackorder">打印条码</el-button>
      <el-button type="danger" size="mini" v-if="!isBackorder&&ssotoken&&!UGO" @click="saveDataNotoken">确认采购（不推送给供应商）</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">{{isBackorder?'生成退货单':'生成采购单'}}</el-button>
    </div>
    <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
    <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
    <BuyfromFastCheckFrame ref="BuyfromFastCheckFrame" @afterCheckIn="afterCheckIn"></BuyfromFastCheckFrame>
    <ewmPay ref="ewmPay1" @UnionPay="afterUnionPay" :ewmpre="'batchbuyorderdetailedit'" @CancelUnionPay="afterCancelUnionPay"></ewmPay>
    <StoreDetailListSupplySee ref="OrderSupplySee1" :showcostprice="false" :allowSelect="true" @afterSelect="afterSelectOrder"></StoreDetailListSupplySee>
    <SupplyShop ref="SupplyShop" @afterSelect="afterShopSelect"></SupplyShop>
  </el-dialog>
</template>


<script>

  import {suppliers} from '@/api/set/externaldept';
  import {createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {login, createFrameOrder,createOrder} from '@/api/ossi';
  import {sortByKey} from '@/api/dateUtil';
  import ewmPay from './ewmPay';
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';
  import SupplyShop from './SupplyShop';
  import {barcodePrint} from '@/api/file';
  import {checkModuleRight} from '@/api/login'
  import {getRemark} from '@/plugin/ordercommon'
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import {buyodersavedetail, SSOrelatedOrder} from '@/api/set/csagreement';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {listgoodsframe, getDetail, getGoodsTree,jingjiaupload} from '@/api/set/jxcgooddetail'
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import {weiyimalist} from '@/api/set/jxcstoregoodsbarcode';
  import MakeInventoryFrameAdd from '../../warehouse/MakeInventoryFrameAdd';
  import StoreDetailListSupplySee from '../../account/StoreDetailListSupplySee'
  import BuyfromFastCheckFrame from '@/components/testorder/buyagreement/BuyfromFastCheckFrame'
  import {isUGO} from '@/api/login';

  export default {
    name: 'BatchBuyorderDetailEdit',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssoT:false,
        ssotoken:"",
        website:"",
        userInfoModel: {},
        data: '2',
        allSupply:false,
        searchmodel:'',
        fixedprice:false,
        didata: '',
        iddata: '',
        dialogFormVisible: false,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        catattributes:{},
        remark: '',
        isBackorder:false,
        cangkucode: '',
        cangkuname: '',
        invoicesource:1,
        tableData: [
          {column: []},
        ],
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {
          cangkucode: '',
          cangkuname: '',
          adddate: '',
          email: '',
          remark: '',
          pcustomerserial: '',
          pcustomer: ''
        },
        showtitle1: "none",
        jxcstoreData: [],
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        seedcodes: '',
        pingpainame:'',
        tableData: [],
        loading: false,//防止多次提交
        totalnumber: 0,
        pcustomerserial: '',
        UGO:false,
      }

    },
    props:{
      fromdiaobo:false,
    },
    methods: {
      fastCheckIn() {
        this.$refs.BuyfromFastCheckFrame.show({
          erpserial: '',
          pcustomerserial: this.controlData.pcustomerserial,
          categoryname: this.pingpainame,
          seedinfo: this.form.seedcode,
          seedcode: this.form.seedcode,
          seedname: this.form.seedname,
          cangkucode: this.controlData.cangkucode,
          cangkuname: this.controlData.cangkuname,
          pcustomerserial: this.controlData.pcustomerserial,
          pcustomer: this.controlData.pcustomer,
          remark:this.controlData.remark,
        }, null);
      },
      afterCheckIn() {
        this.$message({
          message: '采购单生成成功！',
          type: 'success'
        })
        this.$emit('bindGrid');
        this.dialogSeeVisible = false;
      },
      loadfromorder() {//选择采购单
        var end = new Date();//当天
        var year = end.getFullYear();
        var month = end.getMonth() + 1;
        var searchdatevalue = [(month > 6 ? (year + '-' + (month - 6)) : ((year - 1) + '-' + (6 + month))) + '-' + end.getDate(),
          year + '-' + month + '-' + end.getDate()];
        this.$refs.OrderSupplySee1.initData({
          applybydserial: this.controlData.pcustomerserial,
          applybydname: this.controlData.pcustomer,
          otherparam:{
            searchstatus:'1',
            categorycode:this.form.seedcode,
            categoryname:this.form.seedname,
          }
        }, 3, searchdatevalue, "");
        this.$refs.OrderSupplySee1.show();
      },
      afterSelectOrder(orderDetail) {
        var arr = [];
        for (let i in orderDetail.goodsDetail[0].billmap) {
          var row = orderDetail.goodsDetail[0].billmap[i];
          if(!row.seedcode) continue;
          if(!row.packagesize||!row.packagesize.indexOf('C')==-1) {
            this.$message.error("请选择镜架类订单！")
            return;
          }
          var pg=JSON.parse(row.packagesize);
          pg.P=Math.abs(row["数量"]);
          pg.seedcode=row["seedcode"];
          pg.seedname=row["产品名称"];
          arr.push(pg);
        }
        if(arr.length>0) {
          this.afterSelect(arr);
        }
      },
      afterShopSelect(shopgoods) {
        //重新拉取型号
        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
          pcustomerserial:this.fixedprice?this.controlData.pcustomerserial:''

        }).then(resGoods => {
          this.seedcodeData = resGoods.data.obj
        });

        this.afterSelectCode(shopgoods);
      },
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      //回车跳入下一行
      validateCounts(row, index, e ,pre) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[pre+row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[pre + (index + 1)].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[pre+row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[pre + (index - 1)].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      selectonlyonecode(item) {
        for (let i in this.tableData) {
          for (let j in this.tableData[i].barcodes) {
            if (this.tableData[i].barcodes[j].storegoodsbarcode == item.onlycode) {
              item.onlycode = "";
              this.$message({
                message: '唯一码重复！',
                type: 'error'
              })
              return;
            }
          }
        }
        item.barcodes.push({
          storegoodsbarcode: item.onlycode
        });
        item.totalnumber=item.barcodes.length;
        item.onlycode=''
        this.totalNumber()
      },
      clearBar(storegoodsbarcode,item) {
        for (let i in item.barcodes) {
          if (item.barcodes[i].storegoodsbarcode == storegoodsbarcode) {
            item.barcodes.splice(i, 1)
            break;
          }
        }
        item.totalnumber=item.barcodes.length
        this.totalNumber()
      },
      numChange(row) {
        if (parseFloat(row.totalnumber).toString() == 'NaN') {
          row.totalnumber = 0;
        }
        if (row.totalnumber < 0) row.totalnumber = -row.totalnumber ;
        this.totalNumber();
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      jingjiaupload() {
        if (this.controlData.pcustomerserial && this.controlData.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {
          this.$refs.fileupload.value = ""
          this.$refs.fileupload.click()
        } else {
          this.$message({
            message: '请先选择仓库、商品类别、供应商！',
            type: 'error'
          });
        }
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          var onecolor=this.catattributes.onecolor==1;
          this.$importExcel(event.target.files[0], (data) => {
              var catename = this.pingpainame +this.form.seedname.replace(this.pingpainame, '')
              let arr = loadSpecFrame(data, this.form.seedcode, catename,this.catattributes.defaultprice);
              if (arr.length > 0) {
                var loadTable=[]
                var addTable=[]
                for (var i in arr) {
                  if (arr[i].minnumber == 0) {//没填写数量的不导
                    continue;
                  }

                  if (arr[i].costprice && parseFloat(arr[i].costprice) > 0) {//统一供应商名称
                    arr[i].relatedcategoryname = this.controlData.pcustomer;
                  }

                  var MandC = JSON.parse(arr[i].goodsframe)[0];

                  var hasColor = false;
                  //检查是否存在
                  for (let j in this.seedcodeData) {
                    if (this.seedcodeData[j].model == MandC.model&&(!onecolor||this.seedcodeData[j].color==MandC.color)) {//有型号

                      if ((';' + this.seedcodeData[j].color + ';').indexOf(';' + MandC.color + ';') > -1) {
                        hasColor = true;

                        loadTable.push({
                          seedcode: this.seedcodeData[j].seedcode,
                          seedname: this.seedcodeData[j].seedname,
                          color: MandC.color,
                          model: MandC.model,
                          categorycode: this.seedcodeData[j].categorycode,
                          totalnumber: Math.abs(arr[i].minnumber)
                        });
                      }
                      //已有的商品不导价格
                      arr[i].seedname = this.seedcodeData[j].seedname
                      arr[i].seedcode = this.seedcodeData[j].seedcode
                      arr[i].costprice = 0
                      arr[i].refsellprice = 0
                      arr[i].discountdetail = '[]'
                      arr[i].relatedcategoryname = ''

                      break;
                    }
                  }

                  if (!hasColor) {
                    addTable.push(arr[i]);//需要更新商品
                  }
                }

                if(loadTable.length>0){
                  this.afterSelectCode(loadTable);
                }
                if(addTable.length>0){

                  var goods=''

                  for(let i in addTable) {
                    var gf = JSON.parse(addTable[i].goodsframe)[0];
                    goods += (goods ? ' 、 ' : '') + gf.model + '-' + gf.color
                  }

                  const h = this.$createElement;
                  this.$msgbox({
                    title: '以下商品不存在，是否增加到商品库？',
                    message: goods,
                    showCancelButton: true,
                    closeOnClickModal: false,
                    confirmButtonText: '确定增加',
                    cancelButtonText: '取消',
                    beforeClose: (action, instance, done) => {
                      if (action === 'confirm') {
                        //先补录产品
                        jingjiaupload({arr: JSON.stringify(addTable)}).then(response => {
                          if (response.data.code == 0) {
                            var returnSeed = response.data.obj;
                            if (returnSeed == null) returnSeed = [];

                            loadTable = [];
                            for (let i in addTable) {

                              //补商品编码
                              if (!addTable[i].seedcode) {
                                for (let j in returnSeed) {
                                  if (returnSeed[j].goodsframe == addTable[i].goodsframe) {
                                    addTable[i].seedcode = returnSeed[j].seedcode
                                    addTable[i].seedname = returnSeed[j].seedname
                                    break;
                                  }
                                }
                              }

                              var gf = JSON.parse(addTable[i].goodsframe)[0];
                              loadTable.push({
                                seedcode: addTable[i].seedcode,
                                seedname: addTable[i].seedname,
                                color: gf.color,
                                model: gf.model,
                                categorycode: addTable[i].categorycode,
                                totalnumber: addTable[i].minnumber
                              });

                            }
                            if (loadTable.length > 0) {
                              //重新拉取型号
                              listgoodsframe({
                                categorycode: this.form.seedcode,
                                filltemplate: '80',
                                pcustomerserial:this.fixedprice?this.controlData.pcustomerserial:''
                              }).then(resGoods => {
                                this.seedcodeData = resGoods.data.obj
                              });

                              this.afterSelectCode(loadTable);
                            }
                          }
                          done();
                        });
                      } else {
                        done();
                      }
                    }
                  }).then(action => {
                    // this.$message({
                    //   type: 'info',
                    //   message: 'action: ' + action
                    // });
                  });

                }
              }
            }
          )
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      addGood(){
        this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData,{cangkucode:this.cangkucode,cangkuname:this.cangkuname})
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("品牌下没有商品");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.controlData.cangkucode, this.seedcodeData, this.controlData.pcustomerserial)
      },
      showSupplySel() {
        this.$refs.SupplyShop.initData(this.ssotoken, this.form.seedcode, this.form.seedname, this.controlData.pcustomer);
      },
      afterSelect(arr) {
        for (var i in arr) {
          var hasValue = false;
          for (var j in this.tableData) {
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].M && this.tableData[j].color == arr[i].C) {//在库存里的
              this.tableData[j].totalnumber += Math.abs(arr[i].P);
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color: arr[i].C,
              model: arr[i].M,
              categorycode: arr[i].categorycode,
              totalnumber: Math.abs(arr[i].P),
              formproperty: '[{}]',
              packagesize: '{"M":"' + arr[i].M + '","C":"' + arr[i].C + '"}',
              onlycode: '',
              barcodes: []
            })
          }
        }
        this.sortTable();
        this.totalNumber();
      },
      sortTable(){
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color) {
              biaoji = 1
              this.tableData[j].totalnumber = Math.abs(arr[i].totalnumber);//更新数量
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: Math.abs(arr[i].totalnumber),
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              onlycode:'',
              barcodes:[]
            })
          }
        }
        this.sortTable();
        this.totalNumber();
        // if (count > 0) {
        //   this.$message({
        //     message: "商品已存在！",
        //     type: 'info'
        //   })
        // }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //页面标题
      getTitle() {
        let result = (this.userInfoModel.independentserial?this.userInfoModel.independentfdname:this.userInfoModel.tenantname)
        result += "采购订单"
        return result
      },
      customerInitSSO() {
        this.ssotoken = ""
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == this.controlData.pcustomerserial) {
            if (this.ptableData[i].usesso == 1 && this.ptableData[i].ssocode) {
              login({idencode: this.ptableData[i].ssocode, tenantid: this.userInfoModel.tenantid, independentserial: this.userInfoModel.independentserial}).then(loginres => {
                if (loginres.data.code == 0) {
                  this.ssotoken = loginres.data.msg;
                  this.website = loginres.data.website;
                } else {
                  this.$message({message: loginres.data.msg, type: 'error'})
                }
              });
            }
            break;
          }
        }
      },
      changepcu(val) {
        this.ssotoken = "";
        if (this.fromdiaobo) {

        } else {
          this.tableData = [];
          this.seedcodeData = []
          this.form.seedcode = ''
          this.form.seedname = ''
          this.form.seedinfo = '';
          this.$refs.treeSeed.reset();
        }
        this.totalNumber();
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.email = this.ptableData[i].email
            this.customerInitSSO();
            if(this.fixedprice){
              this.bindData();
            }
            break;
          }
        }
      },
      checktree1(guids, names, arr) {
        if (names == "") {
          this.$message({
            message: '请选择类别',
            type: 'error'
          })
          return
        }

        if (this.fixedprice) {
          if (!this.controlData.pcustomerserial) {
            this.$refs.treeSeed.reset();
            this.$message({message: '请先选择供应商', type: 'error'})
            return
          }
        } else {
          this.tableData = [];
        }

        this.seedcodeData = []
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = guids + ";" + names;
        this.catattributes = arr[0].attributes;
        if (guids.length == 12) {
          var nodes = this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3));
          this.pingpainame = nodes.label;
          this.catattributes.onecolor = nodes.data.attributes.onecolor;
        } else {
          this.pingpainame = names;//this.$refs.treeSeed.getNode(guids).label;
        }
        this.pingpainame = guids.length == 12 ? (this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label) :
          (this.$refs.treeSeed.getNode(guids).label);


        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
          pcustomerserial: this.fixedprice ? this.controlData.pcustomerserial : ''
        }).then(response => {
          this.seedcodeData = response.data.obj
          //this.geterweibiao();
          if (this.seedcodeData.length > 0) {
            for (let i in this.seedcodeData) {
              this.seedcodeData[i].totalnumber = 0
            }
            if (this.seedcodeData.length == 1 && (!this.seedcodeData[0].color || this.seedcodeData[0].color.indexOf(';') == -1)) {//单型号、单色号 直接加一条商品
              var oneRow = this.seedcodeData[0];
              this.afterSelect([{
                seedcode: oneRow.seedcode,
                seedname: oneRow.seedname,
                categorycode: oneRow.categorycode,
                P: 1,
                M: oneRow.model,
                C: oneRow.color
              }]);
              this.totalNumber();
            } else {
              this.addGood();
            }
          } else {
            // this.$message({
            //   message: '该系列没有备货商品',
            //   type: 'warning'
            // })
            return
          }

        }).catch((error) => {
          console.log(error)
        });
      },
      //判断是否有供应商
      geterweibiao() {
        this.ssotoken = ""
        this.pcustomerserial=""
        suppliers({categorycode: '', search: ""}).then((response) => {
          this.ptableData = response.data.obj
        })
      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;005;004;006;011',fixedprice:this.fixedprice?1:0,
            pcustomerserial:this.fixedprice?this.controlData.pcustomerserial:''})
        })
      },
      //备注格式化
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      createBarcode(printtype) {
        this.loading=true;
        var number = 0;
        for (let i in this.tableData) {
          var tn = this.tableData[i].totalnumber | 0;
          var scancount = this.tableData[i].barcodes.length;

          if (tn <= 0) {
            this.$message({message: '数量必须大于0！', type: 'error'})
            return;
          }
          if (tn > scancount) {
            number += tn - scancount;
          }
        }

        this.loading=true;
        if (number > 0) {
          //获取条码
          createGoodsbarcode({number: number}).then(response => {
            if (response.data.code == 0) {
              var codePre = response.data.codepre;
              var num = response.data.num;
              //item.model + item.color + '-' +
              for (let i in this.tableData) {
                var item = this.tableData[i];
                var tn = item.totalnumber | 0;
                var scancount = item.barcodes.length;
                for (let j = 0; j < tn - scancount; j++) {
                  item.barcodes.push({
                    storegoodsbarcode:  codePre + this.padleft((num - number + 1).toString(), 3, '0')
                  });
                  number = number - 1;
                }
              }
              this.barcodePDF(printtype);
            }
          });
        } else {
          this.barcodePDF(printtype);
        }
      },
      barcodePDF(printtype) {
        var barcode = [];
        for (let i in this.tableData) {
          var item = this.tableData[i];
          for (let j in item.barcodes) {
            barcode.push({
              barcode: item.barcodes[j].storegoodsbarcode, seedcode: item.seedcode, model: item.model, color: item.color
            });
          }
        }
        barcodePrint(barcode, null,printtype);
        this.loading = false;
      },
      padleft(ret,width,padChar) {
        while (ret.length < width) {
          ret = padChar + ret;
        }
        return ret;
      },
      show() {
        this.dialogSeeVisible = true;
        this.geterweibiao();
      },
      //仓库选择后获取仓库名
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      saveDataNotoken(){
        this.saveData('notoken');
      },
      saveData(notoken) {
        //取出对应的表单详情和数量
        var arr = [];
        var barcodes = [];
        if (!this.controlData.pcustomerserial) {
          this.$message({
            message: '请选择供应商！',
            type: 'error'
          })
          return
        }
        if (!this.controlData.cangkucode) {
          this.$message({
            message: '请选择仓库！',
            type: 'error'
          })
          return
        }
        var seedcodelist = ';'
        for (let i in this.tableData) {
          if (this.tableData[i].totalnumber != 0) {
            if (seedcodelist.indexOf(';' + this.tableData[i].seedcode + ';') == -1)
              seedcodelist += this.tableData[i].seedcode + ';';
            arr.push({
              seedcode: this.tableData[i].seedcode,
              seedname: this.tableData[i].seedname,
              P: this.tableData[i].totalnumber,
              formproperty: '[{}]',
              packagesize: this.tableData[i].packagesize,
            })

            if (this.tableData[i].barcodes.length > 0 && parseInt(this.tableData[i].totalnumber) != this.tableData[i].barcodes.length) {
              this.$message({
                message: '填写的数量和扫码数量不一致！',
                type: 'error'
              })
              return
            }

            for (let j in this.tableData[i].barcodes) {
              var item = this.tableData[i].barcodes[j];
              barcodes.push({
                storegoodsbarcode: item.storegoodsbarcode,
                seedcode: this.tableData[i].seedcode,
                packagesize: this.tableData[i].packagesize
              })
            }

          } else {
            this.$message({
              message: this.tableData[i].seedname + ',没有填写数量！',
              type: 'error'
            })
            return
          }
        }
        this.ssoT = true;
        var ssoTok = this.ssotoken;
        if (notoken && notoken == 'notoken') {
          ssoTok = "";
          this.ssoT = false;
        }
        if (ssoTok && !this.isBackorder) {//需要向供应商发起采购
          if (arr.length <= 0 && !this.controlData.remark) {
            this.$message({message: '请填写采购需求！', type: 'error'})
            return
          }
          //收货地址
          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          //商品明细
          var buyForms = [];
          for (let j in arr) {
            var pg = JSON.parse(arr[j].packagesize);
            if(this.UGO){
              pg["seedcode"] = arr[j].seedcode;
              pg["Number"] = arr[j].P;
            }else{
              pg["P"] = arr[j].P;
            }
            buyForms.push(pg);
          }

          var buyRemark = '[]';
          if (this.controlData.remark && this.controlData.remark != '[]') {
            var remarkArr = [];
            remarkArr.push({"msg": this.controlData.remark, "date": "", "uname": "", "type": "采购需求"});
            buyRemark = JSON.stringify(remarkArr);
          }

          var paramItem = {
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            formproperty: JSON.stringify(buyForms),
            remark: buyRemark,
          };

          if (this.UGO) {//镜架都需要匹配产品编码
            if (arr.length <= 0) {
              this.$message({
                message: '请选择商品！',
                type: 'error'
              })
              return
            }

            createOrder(paramItem, this.ssotoken).then(response => {
              this.afterPost2B2B(response, arr, seedcodelist, barcodes);
            });
          } else {
            paramItem.seedname=this.form.seedcode + ';' + this.pingpainame;//品牌名称
            createFrameOrder(paramItem, this.ssotoken).then(response => {
              this.afterPost2B2B(response, arr, seedcodelist, barcodes);
            });
          }
        } else {
          if (arr.length <= 0) {
            this.$message({
              message: '请选择商品！',
              type: 'error'
            })
            return
          }

          if (this.isBackorder) {
            for (let i in arr) {
              if (parseInt(arr[i].P) > 0) {
                arr[i].P = -arr[i].P;
              }
            }
          }
          this.postBuyData(arr, '保存成功！', seedcodelist, barcodes);
        }
      },
      afterPost2B2B(response,arr,seedcodelist,barcodes){
        var OrderData=response.data;
        this.tracknum = OrderData.erpserial;
        if (OrderData.code == 0) {
          if (arr.length == 0) {//默认初始化一条品牌记录
            arr.push({seedname: this.pingpainame, seedcode: this.form.seedcode, type: 'category'});
            seedcodelist="nocode";
          }
          this.postBuyData(arr, '上游订单已生成，供应商单号：' + this.tracknum, seedcodelist, barcodes);
        } else {
          if (OrderData.groupguid) {//打开支付页面
            if (!OrderData.paytype == 'unionpay') {
              this.$message({message: '尚未开通支付通道！', type: 'error'});
              return;
            }
            OrderData.postdata = arr;
            OrderData.seedcodelist = seedcodelist;
            OrderData.barcodes = barcodes;
            this.$refs.ewmPay1.show(OrderData, this.ssotoken);
          } else {
            this.$message({
              message: OrderData.msg ?OrderData.msg : '提交给供应商出错，请联系管理员！',
              type: 'error'
            })
            this.loading = false
          }
        }
      },
      postBuyData(arr, msg,seedcodelist,barcodes) {
        this.loading = true
        buyodersavedetail({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify({
            pcustomerserial: this.controlData.pcustomerserial,
            pcustomer: this.controlData.pcustomer,
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode,
            address: '',
            linkman: '',
            linkmantel: '',
            seedcode: this.form.seedcode,
            seedname: this.form.seedname,
            seedinfo: this.form.seedinfo,
            remark: this.controlData.remark ? this.controlData.remark : '',
            tracknum: this.tracknum.trim(),//供应商单号
            isdistribute: '80',//镜架仓库录入的入库单
            logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
            invoicesource: this.invoicesource,//1 是 待审核
            status: 810,
            seedcodelist: seedcodelist,
            barcodes: JSON.stringify(barcodes),
          })
        }).then(response => {
          if (response.data.code == 0) {
            if (this.ssotoken&&this.ssoT) {
              SSOrelatedOrder({
                erpserial: this.tracknum.trim(), parenterpserial: response.data.obj.erpserial, uname: '客户采购单号',customername:this.controlData.cangkuname.replace('仓库','')
              }, this.ssotoken).then(response => {
              })
            }
            this.$message({
              message: msg,
              type: 'success'
            })
            this.$emit('bindGrid');
            //this.lookbuyorderdetail(response.data.obj, 1)
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading = false
          }
          this.dialogSeeVisible = false;
          //刷新列表
        });
      },
      afterUnionPay(row){
        this.postBuyData(row.postdata, '支付成功！上游订单已生成，供应商单号：' + this.tracknum + '',row.seedcodelist, row.barcodes);
      },
      afterCancelUnionPay(row){//撤销支付
        backOrder({erpserial: row.erpserial}, this.ssotoken).then(resDel => {
          this.loading = false;
        });
      },
      initData(row) {
        this.initForm();
        if (row == null)
          return;
        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.form.seedinfo = ""
          this.catattributes = {}
        }
        this.index = -99
        this.form.seedcode = ''
        this.form.seedname = ''
      },
      CurentTime() {
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        var clock = year + "-";

        if (month < 10)
          clock += "0";

        clock += month + "-";

        if (day < 10)
          clock += "0";

        clock += day + " ";

        if (hh < 10)
          clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        return (clock);
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.isBackorder=false;
        this.pcustomerserial=''
        this.ptableData=[]
        this.form.seedname=''
        this.form.seedcode=''
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer =''
        this.controlData.remark='';
        this.groupguid = ""
        this.column = []
        this.ssotoken = ""
        this.tableData = []
        this.unitguid = ""
        this.tracknum = ''
        this.logisticstracknum = ''
        this.loading = false
        this.totalnumber = 0
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel = JSON.parse(temp);
      }
      this.invoicesource = 1;
      this.UGO=isUGO();
      checkModuleRight({name: 'framenoaudit'}).then(reponse => {
        this.invoicesource = reponse.data.code == 0 ? 0 : 1;
      });
      checkModuleRight({name: 'fixedprice'}).then(reponse => {
        this.fixedprice = reponse.data.code == 0 ;
      });
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;

        this.changename(this.controlData.cangkucode);
      })
    },
    components: {
      BatchBuyFormProperties,
      BuyfromSupplyer,
      StoreDetailListSupplySee,
      MakeInventoryFrameAdd,
      BuyfromFastCheckFrame,
      SupplyShop,
      ewmPay
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BatchBuyorderDetailEdit.vue